import { laneYMeters } from "./tunnelUtils";

export const calculateGridPositions = (
  count,
  rows,
  cols,
  startX,
  startY,
  spacingX,
  spacingY
) => {
  const positions = [];
  for (let i = 0; i < count; i++) {
    const row = Math.floor(i / cols);
    const col = i % cols;
    positions.push({
      x: startX + col * spacingX,
      y: startY + row * spacingY,
    });
  }
  return positions;
};

export const calculateLinePositions = (
  count,
  startX,
  startY,
  spacing,
  direction,
  angle = 45
) => {
  const positions = [];
  const radians = (angle * Math.PI) / 180;

  for (let i = 0; i < count; i++) {
    const distance = i * spacing;
    let dx, dy;

    if (direction === "horizontal") {
      dx = distance;
      dy = 0;
    } else if (direction === "vertical") {
      dx = 0;
      dy = distance;
    } else {
      dx = distance * Math.cos(radians);
      dy = distance * Math.sin(radians);
    }

    positions.push({
      x: startX + dx,
      y: startY + dy,
    });
  }
  return positions;
};

export const calculateEvenDistribution = (count, lineWidth) => {
  const positions = [];
  const spacing = lineWidth / (count + 1);

  for (let i = 0; i < count; i++) {
    positions.push({ x: spacing * (i + 1) });
  }
  return positions;
};

export const calculateFixedSpacing = (count, startPosition, spacing) => {
  const positions = [];

  for (let i = 0; i < count; i++) {
    positions.push({ x: startPosition + i * spacing });
  }
  return positions;
};

export const validatePositions = (positions, dimensions, is1D = false) => {
  return positions.every((pos) => {
    const xValid = pos.x >= 0 && pos.x <= dimensions.width;
    if (is1D) {
      return xValid;
    }
    const yValid = pos.y >= 0 && pos.y <= dimensions.height;
    return xValid && yValid;
  });
};

export const getSmartGridDefaults = (count) => {
  const sqrt = Math.sqrt(count);
  const cols = Math.ceil(sqrt);
  const rows = Math.ceil(count / cols);
  return { rows, cols };
};

export const calculateTunnelPositions = (
  count,
  lineWidth,
  lineHeight,
  pattern,
  params = {}
) => {
  const positions = [];
  const upperLaneY = laneYMeters("upper", lineHeight);
  const lowerLaneY = laneYMeters("lower", lineHeight);

  if (pattern === "alternating") {
    const spacing = lineWidth / Math.ceil(count / 2 + 1);
    let upperIdx = 0,
      lowerIdx = 0;

    for (let i = 0; i < count; i++) {
      if (i % 2 === 0) {
        positions.push({
          x: spacing * (upperIdx + 1),
          y: upperLaneY,
        });
        upperIdx++;
      } else {
        positions.push({
          x: spacing * (lowerIdx + 1),
          y: lowerLaneY,
        });
        lowerIdx++;
      }
    }
  } else if (pattern === "fill-upper-first") {
    const perLane = Math.ceil(count / 2);
    const spacing = lineWidth / (perLane + 1);

    for (let i = 0; i < count; i++) {
      const isUpper = i < perLane;
      const laneIdx = i < perLane ? i : i - perLane;
      positions.push({
        x: spacing * (laneIdx + 1),
        y: isUpper ? upperLaneY : lowerLaneY,
      });
    }
  } else if (pattern === "even-both") {
    const upperCount = Math.ceil(count / 2);
    const lowerCount = count - upperCount;
    const upperSpacing = lineWidth / (upperCount + 1);
    const lowerSpacing = lineWidth / (lowerCount + 1);

    for (let i = 0; i < upperCount; i++) {
      positions.push({ x: upperSpacing * (i + 1), y: upperLaneY });
    }
    for (let i = 0; i < lowerCount; i++) {
      positions.push({ x: lowerSpacing * (i + 1), y: lowerLaneY });
    }
  } else if (pattern === "custom") {
    const { startPosition = 0, spacing = 5, targetLane = "upper" } = params;
    const y = targetLane === "upper" ? upperLaneY : lowerLaneY;

    for (let i = 0; i < count; i++) {
      positions.push({ x: startPosition + i * spacing, y });
    }
  }

  return positions;
};

export const validateTunnelPositions = (positions, dimensions) => {
  return positions.every((pos) => {
    const xValid = pos.x >= 0 && pos.x <= dimensions.width;
    const yValid = pos.y >= 0 && pos.y <= dimensions.height;
    return xValid && yValid;
  });
};

